import React from "react";
import { UserResource } from "../../../resources";
import { Grid, Typography, Theme } from "@material-ui/core";
import { FormattedMessage } from "react-intl";
import { makeStyles } from "@material-ui/styles";
import FaceIcon from "@material-ui/icons/Face";
import { useCommonWidths } from "../../../hooks";
import { useResource } from "rest-hooks";

const useStyles = makeStyles((theme: Theme) => ({
	userNameContainer: {
		paddingLeft: theme.spacing(1),
		alignSelf: "center",
		width: "fit-content",
		marginRight: 40,
		[theme.breakpoints.down("sm")]: {
			margin: "0 8px",
			paddingLeft: 0,
		},
	},
	profileIconSize: {
		[theme.breakpoints.up("md")]: {
			height: 35,
			alignSelf: "center"
		},
		fontSize: 40,
		margin: "0 10px",
		[theme.breakpoints.down("sm")]: {
			fontSize: 24,
			margin: 8,
		},
	},
	menuButton: {
		cursor: "pointer",
		color: "white",
		padding: 0,
		height: "100%",
		maxWidth: 400,
		marginRight: 10,
		display: "flex",
		borderColor: "white",
		borderRadius: 50,
		borderWidth: "thin",
		borderStyle: "solid",
		[theme.breakpoints.down("xs")]: {
			maxWidth: 170,
		},
		alignSelf: "center"
	},
	userName: {
		lineHeight: 1.4,
		fontSize: "1.1rem",
		// Truncate too long names (break text, and append "..."):
		whiteSpace: "nowrap",
		textOverflow: "ellipsis",
		overflow: "hidden",
		maxWidth: 320
	},
}));
interface MyProfileMenuIconProps {
	onClick?: () => void;
}
export const MyProfileMenuIcon = (props: MyProfileMenuIconProps) => {
	const { onClick } = props;
	const { fullName } = useResource(UserResource.detailShape(), {});
	const isMobile = useCommonWidths().isSmDown;

	const classes = useStyles();
	return (
		<div onClick={onClick} className={classes.menuButton}>
			<FaceIcon className={classes.profileIconSize} />
			<Grid className={classes.userNameContainer}>
				{!isMobile && (
					<Grid item>
						<Typography
							className={classes.userName}
							component="div"
							variant="subtitle1"
						>
							{fullName}
						</Typography>
					</Grid>
				)}
				<Grid item>
					<Typography
						variant={isMobile ? "subtitle1" : "caption"}
						noWrap
						style={{ opacity: 0.8 }}
					>
						<FormattedMessage
							id="minside.myprofile.my_profile"
							defaultMessage="Min Profil"
							description="My profile text"
						/>
					</Typography>
				</Grid>
			</Grid>
		</div>
	);
};
